import { Controller } from 'stimulus'

export default class TimeagoController extends Controller {
  connect() {
    $(this.element).timeago().tooltip()
  }
}